import {ReactElement} from 'react';

import {Grid, SxProps} from '@mui/material';
interface Props {
  children: ReactElement[] | ReactElement | null;
  gap?: string;
  md?: number;
  sm?: number;
  sx?: SxProps;
}
export const Column = ({children, gap = '10px', md = 6, sm = 6, sx}: Props) => {
  return (
    <Grid item display='flex' flexDirection='column' gap={gap} sm={sm} md={md} marginBottom={gap} sx={sx}>
      {children}
    </Grid>
  );
};
